import React, { useState } from "react";

import UploadBulkFile from "../../components/BulkUpload/UploadBulkFile";
import { BULK_UPLOAD_TABS, CONSTANTS } from "../../constants/constants";

import styles from "./BulkUpload.module.scss";

const { ZERO } = CONSTANTS;

const BulkUpload = () => {
  const [activeTabId, setActiveTabId] = useState(BULK_UPLOAD_TABS[ZERO].id);
  const activeTab =
    BULK_UPLOAD_TABS.find((tab) => tab.id === activeTabId) ||
    BULK_UPLOAD_TABS[ZERO];

  return (
    <div className={styles.mainContainer}>
      <div className={styles.page}>
        <header className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>Bulk Upload</h1>
        </header>
        <div
          className={styles.tabs}
          role="tablist"
          aria-label="Bulk upload type"
        >
          {BULK_UPLOAD_TABS.map((tab) => {
            const isActive = tab.id === activeTabId;

            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                id={`${tab.id}-tab`}
                aria-selected={isActive}
                aria-controls="bulk-upload-tab-panel"
                className={`${styles.tab} ${isActive ? styles.activeTab : ""}`}
                onClick={() => setActiveTabId(tab.id)}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
        <div
          id="bulk-upload-tab-panel"
          role="tabpanel"
          aria-labelledby={`${activeTab.id}-tab`}
        >
          <UploadBulkFile
            key={activeTab.id}
            scriptId={activeTab.scriptId}
            uploadTitle={activeTab.uploadTitle}
            historyTitle={activeTab.historyTitle}
            emptyStateLabel={activeTab.emptyStateLabel}
          />
        </div>
      </div>
    </div>
  );
};

export default BulkUpload;
